import RouteItem from ".";
import About from "../pages/aboutUs/About";
import Founder from "../pages/aboutUs/Founder";
import Management from "../pages/aboutUs/Management";
import MissionAndVission from "../pages/aboutUs/MissionAndVission";
import PatronSaint from "../pages/aboutUs/PatronSaint";
import SchoolEmblem from "../pages/aboutUs/SchoolEmblem";
import PageNotFound from "../pages/error-pages/PageNotFound";
import PageUnderConstruction from "../pages/error-pages/PageUnderConstruction";
import MissionAndVision from "../pages/aboutUs/MissionAndVission";

export const aboutRoutes: RouteItem = {
  key: "router-about",
  title: "About Us",
  tooltip: "About Us",
  description:
    "St. Xavier's School, Gultekdi, Pune is a CBSE-affiliated (Affiliation No. 1131476) Co-Ed School established in 2023. It is named after St. Francis Xavier, a 16th-century saint renowned for his extensive mission in Asia under the Portuguese Empire.",
  path: "/about-us",
  component: <PageNotFound />,
  enabled: true,
  appendDivider: true,
  subRoutesDirection: "vertical",
  subRoutes: [
    {
      key: "router-founder-of-jesuits",
      title: "Founder Of The Jesuits",
      tooltip: "Founder Of The Jesuits",
      path: "founder-of-the-jesuits",
      component: <Founder />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-jesuit-values",
      title: "The Jesuit Core Values",
      tooltip: "The Jesuit Core Values",
      path: "the-jesuit-core-values",
      component: <PageUnderConstruction />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-patron-saint",
      title: "Our School Patron Saint",
      tooltip: "Our School Patron Saint",
      path: "our-school-patron-saint",
      component: <PatronSaint />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-about-school",
      title: "About Our School",
      tooltip: "About Our School",
      path: "about-our-school",
      component: <About />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-our-management",
      title: "Our School Management",
      tooltip: "Our School Management",
      path: "our-school-management",
      component: <Management />,
      enabled: true,
      appendDivider: false, // Last sub-route should not have an appendix divider
    },
    {
      key: "router-mission-vision",
      title: "Our School Mission And Vision",
      tooltip: "Our School Mission And Vision",
      path: "our-school-mission-and-vision",
      component: <MissionAndVision />,
      enabled: true,
      appendDivider: true,
    },
    {
      key: "router-school-emblem",
      title: "The School Emblem",
      tooltip: "The School Emblem",
      path: "the-school-emblem",
      component: <SchoolEmblem />,
      enabled: true,
      appendDivider: true,
    },
  ],
};
